import { useState } from 'react';
import { Checkbox } from '@mui/material';

export const useRowSelect = () => {
  const [seletedIds, setSeletedIds] = useState<number[]>(
    []
  );

  const onAllRowOfPageCheck = (
    ids: number[],
    isPreviouslyChecked: boolean
  ) => {
    if (isPreviouslyChecked) {
      setSeletedIds(
        seletedIds.filter((id) => !ids.includes(id))
      );
    } else {
      setSeletedIds(seletedIds.concat(ids));
    }
  };

  const onRowCheck = (id: number) => {
    const tempSeletedIds = [...seletedIds];
    const index = tempSeletedIds.indexOf(id);
    if (index == -1) {
      tempSeletedIds.push(id);
      setSeletedIds(tempSeletedIds);
    } else {
      tempSeletedIds.splice(index, 1);
      setSeletedIds(tempSeletedIds);
    }
  };

  const isRowChecked = (id: number) =>
    seletedIds.includes(id);

  const isAllRowsOfThePageChecked = (ids: number[]) =>
    ids.reduce(
      (acc, currentId, currentIndex) => {
        const isCurrentRowChecked =
          seletedIds.includes(currentId);
        return {
          allChecked: acc.allChecked && isCurrentRowChecked,
          indeterminate:
            acc.indeterminate ||
            (currentIndex !== 0 &&
              isCurrentRowChecked !== acc.allChecked),
        };
      },
      {
        allChecked: ids.length > 0 ? true : false,
        indeterminate: false,
      }
    );

  const checkbox = (id: number) => (
    <Checkbox
      checked={isRowChecked(id)}
      onClick={() => onRowCheck(id)}
      sx={{
        '&.Mui-checked': {
          color: ' rgba(0, 105, 112, 1)',
        },
      }}
    />
  );

  const selectAllCheckBox = (
    currentPageListDataIds: number[]
  ) => {
    const isAllRowsOfThePageCheckedStatus =
      isAllRowsOfThePageChecked(currentPageListDataIds);
    return (
      <Checkbox
        checked={isAllRowsOfThePageCheckedStatus.allChecked}
        indeterminate={
          isAllRowsOfThePageCheckedStatus.indeterminate
        }
        onClick={() =>
          onAllRowOfPageCheck(
            currentPageListDataIds,
            isAllRowsOfThePageCheckedStatus.allChecked ||
              isAllRowsOfThePageCheckedStatus.indeterminate
          )
        }
        sx={{
          '&.Mui-checked': {
            color: ' rgba(0, 105, 112, 1)',
          },
        }}
      />
    );
  };

  return {
    seletedIds,
    setSeletedIds,
    checkbox,
    selectAllCheckBox,
  };
};
